<div class="header">
  <div class="title">権限変更</div>
</div>
<mat-dialog-content>
  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
    <div class="form-area">
      <form [formGroup]="form">
        <div class="flex">
          <div class="label">ID</div>
          <mat-form-field class="input-area no-line">
            <input matInput
              formControlName="mailaddress"
              readonly
              (input)="onInput()"
              type="text"
              />
          </mat-form-field>
        </div>
        <div class="flex">
          <div class="label">権限</div>
          <mat-form-field floatLabel="never" class="field-auth no-line">
            <mat-select
              formControlName="accountAuth"
              panelWidth=""
              panelClass="tagcategory-select"
              >
            <!-- 現在の権限を表示（選択不可） -->
            @if (currentAuth != 0) {
            <mat-option *ngIf="currentAuth <= loginAuthCode" [value]="currentAuth">
              {{ getAuthLabel(currentAuth) }}
            </mat-option>
            }
            <!-- 変更可能な権限 -->
            <mat-option *ngFor="let auth of auths" [value]="auth.value">
              {{ auth.label }}
            </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
    </form>
  </div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving" class="yes-btn">保存</button>
</mat-dialog-actions>
